var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "error-page" },
    [
      _c("b-container", [
        _c("div", { staticClass: "errorContainer mx-auto" }, [
          _c("h3", { staticClass: "errorInfo" }, [
            _vm._v("\n          This page is under development\n      ")
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }